import { Box, Paper, styled, Table, Typography } from "@mui/material";
import { Container } from "../../components/common/Common.styles";
import { theme } from "../../theme";

const gridGapLg = 40;

export const DashboardContentStyles = styled(Box)({
  width: "100%",
  margin: "11px 0 0 0",
});

export const DashboardGrid = styled(Box)(({ theme }) => ({
  marginTop: "22px",
  width: "100%",
  display: "grid",
  gap: "20px",
  gridTemplateColumns: "repeat(2, 1fr)",
  [theme.breakpoints.down(996)]: {
    gridTemplateColumns: "1fr",
  },
}));

export const GeneralInfoWrapper = styled(Box)({
  width: "96%",
  margin: "0 auto",
  marginBottom: "20px",
});

export const StatisticsWrapper = styled(Container)({
  gap: `${gridGapLg}px`,
  [theme.breakpoints.down(1444)]: {
    flexWrap: "wrap",
  },
});

export const StatisticHeaderContainer = styled(Container)({
  "& > .MuiBox-root:first-child": {
    width: "100%",
  },
  "& > .MuiBox-root:last-child": {
    width: "fit-content",
  },
  "& .MuiTypography-root": {
    marginLeft: "20px",
  },
});

export const GeneralInfoContainer = styled(Container)({
  "& > .MuiBox-root:first-child": {
    width: "100%",
  },
  "& > .MuiBox-root:last-child": {
    width: "fit-content",
  },
  "& .MuiTypography-root": {
    marginLeft: "20px",
  },
  backgroundColor: theme.palette.backgroundColor.main,
  padding: "10px",
  display: "flex",
  justifyContent: "flex-end"
});

export const ActivatedAccountsBox = styled(Container)({
  border: `1px solid ${theme.palette.backgroundColor.secondary}`,
  borderRadius: "5px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "10px",
  width: "50% !important",
  fontSize: "large"
})

export const AccountCounter = styled(Box)({
  fontWeight: "700",
  fontSize: "x-large",
  display: "flex"
})

export const ActivatedAccountsText = styled(Box)({
  width: "70%"
})

export const ActiveUsersText = styled(Box)({
  color: theme.palette.primary.main,
  fontWeight: "bold",
  marginRight: "5px",
});
export const TotalUsersText = styled(Box)({
  color: theme.palette.textMain.secondary,
  opacity: 0.7,
});

export const StatisticInfoStyles = styled(Box)({
  "& > .MuiBox-root > .MuiTypography-root": {
    width: "100%",
  },
  "& > .MuiBox-root > .MuiBox-root": {
    marginLeft: "10px",
    width: "50%",
    minWidth: "20px",
  },
  "& > .MuiTypography-root": {
    color: theme.palette.textMain.secondary,
    textAlign: "right",
  },
  "& .MuiTypography-root": {
    marginLeft: "0!important",
  },
});

export const EvaluationStarsDataWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "10px",
  margin: "10px",
})

export const NoDataContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '10px 0',
  width: '100%',
  height: "100%",
});

export const FeedbackTableContainer = styled(Paper)({
  width: "100%",
  maxHeight: 300,
  overflowY: "auto",
  border: "1px solid #eee",
  marginTop: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  overflow: "hidden",
  boxShadow: theme.shadows[2],
});

export const StyledTable = styled(Table)(({ theme }) => ({
  minWidth: 650,
  "& thead": {
    backgroundColor: theme.palette.grey[100],
  },
}));

export const NoFeedbackContainer = styled(Box)(({ theme }) => ({
  borderRadius: '5px',
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',
}));

export const NoFeedbackText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '1.1rem',
  fontStyle: 'italic',
  marginTop: theme.spacing(2),
  fontWeight: 300,
}));